// extracted by mini-css-extract-plugin
export var cardHeader = "_eh-0";
export var reorderHandle = "_eh-3";
export var titleArea = "_eh-1";
export var titleAreaWithHandle = "_eh-2";